import React from 'react';
import { useParams } from 'react-router-dom';
import { MenuItem } from 'src/components/enterprise/navigation/NavMenu/MenuItem';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';

export const ParentAccountsMenuItems: React.FC = () => {
  const {
    enterpriseData: { isInternalAdminUser },
  } = useAuth();

  const { corpid } = useParams<{ corpid: string }>();

  const childAccountsLink = isInternalAdminUser
    ? `/groupadmin/parents/${corpid}`
    : `/corporate/enterprise/parents/${corpid}/children`;

  return (
    <>
      <MenuItem
        menu="Child accounts"
        mainRoute={childAccountsLink}
        matchingPathnames={[`/corporate/enterprise/parents/${corpid}/children`]}
      />
      <MenuItem
        menu="Parent admins"
        mainRoute={`/corporate/enterprise/parents/${corpid}/admin`}
        matchingPathnames={[`/corporate/enterprise/parents/${corpid}/admin`]}
      />
    </>
  );
};
